/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const GraphPathingIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Graph Pathing',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <rect height="12" rx=".5" ry=".5" width="6" x="2" y="2" />
    <rect height="8" rx=".5" ry=".5" width="8" x="26" y="2" />
    <rect height="8" rx=".5" ry=".5" width="8" x="26" y="14" />
    <rect height="8" rx=".5" ry=".5" width="8" x="26" y="26" />
    <path
      d="M24 6.479a.508.508 0 0 1-.513.5 28.045 28.045 0 0 1-7.35-1.088 22.668 22.668 0 0 0-5.639-.9.5.5 0 0 1-.5-.5v-1a.51.51 0 0 1 .518-.5 24.63 24.63 0 0 1 6.115.965A26.4 26.4 0 0 0 23.5 4.982a.5.5 0 0 1 .5.5ZM24 18.058a.5.5 0 0 1-.525.5c-2.937-.236-4.214-2.459-5.452-4.612-1.532-2.666-2.982-5.189-7.531-5.358A.5.5 0 0 1 10 8.1v-1a.505.505 0 0 1 .517-.5c5.7.194 7.657 3.606 9.241 6.362 1.225 2.132 2.045 3.412 3.769 3.6a.511.511 0 0 1 .473.5Z"
    />
    <path
      d="M24 30.452a.51.51 0 0 1-.591.5c-3.2-.431-4.6-4.385-6.079-8.557-1.573-4.437-3.2-9.019-6.858-9.381a.505.505 0 0 1-.472-.499v-1.007a.5.5 0 0 1 .525-.5c5.02.357 6.966 5.851 8.69 10.718 1.249 3.522 2.432 6.862 4.417 7.23a.479.479 0 0 1 .368.481Z"
    />
  </svg>`;
};
